import { __decorate } from "tslib";
import { Vue, Component, Mixins } from "vue-property-decorator";
import { uiMapper } from "@/services/store/modules/ui/store";
import InfoSkills from "@/components/InfoSkills.vue";
import ItemSkill from "@/components/ItemSkill.vue";
import ButtonApp from "@/components/ButtonApp.vue";
const UiMappers = Vue.extend({
    computed: {
        ...uiMapper.mapState(["breakpoint"]),
        ...uiMapper.mapGetters(["isTouchDevice"]),
    },
});
const DataMappers = Vue.extend({});
let ScreenSkills = class ScreenSkills extends Mixins(UiMappers, DataMappers) {
    constructor() {
        super(...arguments);
        this.skills = [
            "Коммуникация",
            "Креативность",
            "Критическое мышление",
            "Работа в&nbsp;команде",
            "Стрессоустойчивость",
            "Доброжелательность и&nbsp;отзывчивость",
            "Лидерство",
            "Умение ставить цели",
            "Умение планировать время",
            "Эмоциональный интеллект",
            "Умение слушать",
            "Самопрезентация",
            "Способность убеждать людей",
            "Владение речью, мимикой и&nbsp;жестами",
            "Умение доказывать свою точку зрения",
            "Концентрация внимания",
            "Компетенции в&nbsp;IT",
            "Экологическое мышление",
            "Усидчивость, терпение",
            "Умение улаживать конфликты",
        ];
    }
    get isXs() {
        return this.breakpoint === "xs";
    }
    get isSm() {
        return this.breakpoint === "sm";
    }
};
ScreenSkills = __decorate([
    Component({
        components: {
            InfoSkills,
            ItemSkill,
            ButtonApp,
        },
    })
], ScreenSkills);
export default ScreenSkills;
